export default __webpack_public_path__ + "static/project-1-dc194be44b64950165b3a8b15d389878.png";